export default __webpack_public_path__ + "static/media/IMG_4965.562ae671.png";